import React from 'react';
import omit from 'lodash/omit';
import axios from 'axios';
import * as actions from './actions';
import { lawsAPI, lawsAPILite } from '~api/laws';
import { newsAPI, newsAPILite } from '~api/news';
import { toast } from 'react-toastify';
import { ErrorMessage, SuccessMessage } from '~components/toast';
import { resetAnalytics } from '~utils/analytics';
import { checkUserExpirationDateExpired } from '~utils/helpers';

export const setUserFetching = (isFetching) => ({
    type: actions.SET_USER_FETCHING,
    isFetching,
});

export function signup(userData) {
    return async (dispatch) => {
        return await newsAPILite()
            .post('/auth/register/', {
                username: userData.username,
                email: userData.email,
                password: userData.password,
                first_name: userData.first_name,
                last_name: userData.lastName,
                role: userData.role,
            })
            .then(({ data }) => data)
            .catch((error) => {
                toast(<ErrorMessage message={error.message} />);
                return error.message;
            });
    };
}

export function logIn(user) {
    // console.log('+++LOGIN USER 33+++');
    return { type: actions.LOGIN, user };
}

export function logUser(userData) {
    return async (dispatch) => {
        dispatch(setUserFetching(true));
        const { username, password } = userData;
        let user = {
            newsUser: {
                id: '',
                token: null,
                token_expires_at: null,
            },
        };

        const newsResponse = await newsAPILite()
            .post('/auth/login/', { username, password })
            .then((res) => res)
            .catch((error) => ({ error }));

        if (newsResponse && newsResponse.data) {
            user = {
                ...omit(newsResponse.data.user, ['id']),
                newsUser: {
                    id: newsResponse.data.user.id,
                    token: newsResponse.data.token,
                    token_expires_at: newsResponse.data.token_expires_at,
                },
                lawsUser: {
                    id: '',
                    token: null,
                    token_expires_at: null,
                },
            };
        }

        const lawsResponse = await lawsAPILite()
            .post('/auth/login/', { username, password })
            .then((res) => res)
            .catch((error) => ({ error }));

        if (lawsResponse && lawsResponse.data) {
            const group = Array.isArray(lawsResponse.data.user.groups) ? lawsResponse.data.user.groups[0] : null;
            const listEcosystemFunctions = group &&
                Array.isArray(group.ecosystem_functions) && [...group.ecosystem_functions];
            let ecosystemFunctions = {};
            Array.isArray(listEcosystemFunctions) &&
                listEcosystemFunctions.map((item) => (ecosystemFunctions[item.code] = true));
            const company = group ? group.company : null;
            const listSubdivisions = company ? company.groups : null;
            user = {
                ...user,
                ...omit(lawsResponse.data.user, ['id', 'groups']),
                group: Array.isArray(lawsResponse.data.user.groups) ? lawsResponse.data.user.groups[0] : null,
                ecosystem: {
                    functions: ecosystemFunctions,
                    listFunctions: listEcosystemFunctions,
                    company,
                    listSubdivisions: listSubdivisions || null,
                },
                lawsUser: {
                    id: lawsResponse.data.user.id,
                    token: lawsResponse.data.token,
                    token_expires_at: lawsResponse.data.token_expires_at,
                },
            };
        }
        const newsError = newsResponse.error;
        const lawsError = lawsResponse.error;

        const isNewsCreditionalsError = newsError && newsError.response && newsError.response.status === 400;
        const isLawsCreditionalsError = lawsError && lawsError.response && lawsError.response.status === 400;

        // console.log(
        //     '+++IS ERROR+++',
        //     newsResponse,
        //     lawsResponse,
        //     // isNewsCreditionalsError,
        //     // isLawsCreditionalsError,
        //     newsError,
        //     lawsError
        // );

        // if (isNewsCreditionalsError && isLawsCreditionalsError) {
        if (newsError && lawsError) {
            // console.log('+++NO ACC+++');
            toast(
                <ErrorMessage
                    message={
                        <div>
                            <div>Нет аккаунта с такими данными.</div>
                            <div>Пожалуйста, проверьте введенные логин и пароль</div>
                        </div>
                    }
                />
            );
            dispatch(setUserFetching(false));
            return null;
        }

        dispatch(logIn(user));
        return user;
    };
}

export function updateUser(userData) {
    console.log('+++UPDATE USER+++', userData);
    return (dispatch) => {
        dispatch({
            type: actions.UPDATE_USER,
            userData,
        });
    };
}

// вспомагательная, не actionCreator
async function getUser(apiInstance, cancelToken) {
    console.log('+++GET USER+++');
    return await apiInstance()
        .get('/auth/user/', { cancelToken })
        .then((res) => res)
        .catch((error) => {
            if (axios.isCancel(error)) {
                return { error: 'cancel' };
            } else if (error.response.status === 400) {
                const err = error.response && error.response.data && error.response.data.email;
                toast(<ErrorMessage message={err[0]} />);
            } else {
                toast(<ErrorMessage message={`[get userdata error]: ${error.message}`} />);
            }
            console.error(`[get userdata error]: ${error.message}`);
            return { error: 'error' };
        });
}

// вспомагательная, не actionCreator
export function getUserData(cancelToken) {
    console.log('+++GET USER DATA+++');
    if (!cancelToken) throw new Error('getUserData: cancelToken was not specified');
    // cancelToken можно использовать один на оба запроса
    // функция возращает только строки - 'cancel', 'error', 'ok'
    return async (dispatch, getState) => {
        const user = getState().user;
        const isNewsUserLogged = !checkUserExpirationDateExpired(user.newsUser.token_expires_at);
        const isLawsUserLogged = !checkUserExpirationDateExpired(user.lawsUser.token_expires_at);

        let newsResponse = null;
        let lawsResponse = null;

        if (isNewsUserLogged) {
            newsResponse = await getUser(newsAPI, cancelToken);
        }
        if (isLawsUserLogged) {
            lawsResponse = await getUser(lawsAPI, cancelToken);
        }
        if (isNewsUserLogged && isLawsUserLogged && newsResponse.data && lawsResponse.data) {
            updateUser({
                ...omit(user, ['id']),
                ...omit(newsResponse.data, ['id']),
                ...omit(lawsResponse.data, ['id']),
            });
            return 'ok';
        }
        if (isNewsUserLogged && !isLawsUserLogged && newsResponse.data) {
            updateUser({ ...omit(user, ['id']), ...omit(newsResponse.data, ['id']) });
            return 'ok';
        }
        if (isLawsUserLogged && !isNewsUserLogged && lawsResponse.data) {
            updateUser({ ...omit(user, ['id']), ...omit(lawsResponse.data, ['id']) });
            return 'ok';
        }
        if (newsResponse.error) return newsResponse.error;
        if (lawsResponse.error) return lawsResponse.error;
    };
}

async function patchUser(apiInstance, id, payload, cancelToken) {
    return await apiInstance()
        .patch(`/users/${id}/`, payload, { cancelToken })
        .then((res) => res)
        .catch((error) => {
            if (axios.isCancel(error)) {
                return { error: 'cancel' };
            } else if (error.response.status === 400) {
                const err = error.response && error.response.data && error.response.data.email;
                toast(<ErrorMessage message={err[0]} />);
            } else {
                toast(<ErrorMessage message={`Updating userdata error: ${error.message}`} />);
            }
            console.error(`Updating userdata error: ${error.message}`);
            return { error: 'error' };
        });
}

export function updateUserData(payload, cancelToken) {
    console.log('+++UPDATE USER DATA+++');
    if (!cancelToken) throw new Error('updateUserData: cancelToken was not specified');
    // cancelToken можно использовать один на оба запроса
    // функция возращает только строки - 'cancel', 'error', 'ok'
    return async (dispatch, getState) => {
        const user = getState().user;
        const isNewsUserLogged =
            user.newsUser &&
            user.newsUser.token !== null &&
            user.newsUser.token_expires_at !== null &&
            user.newsUser.token_expires_at > Date.now();
        const isLawsUserLogged =
            user.lawsUser &&
            user.lawsUser.token !== null &&
            user.lawsUser.token_expires_at !== null &&
            user.lawsUser.token_expires_at > Date.now();

        let newsResponse = null;
        let lawsResponse = null;

        if (isNewsUserLogged) {
            newsResponse = await patchUser(newsAPI, user.newsUser.id, payload, cancelToken);
        }

        if (isLawsUserLogged) {
            lawsResponse = await patchUser(lawsAPI, user.lawsUser.id, payload, cancelToken);
        }

        if (isNewsUserLogged && isLawsUserLogged && newsResponse.data && lawsResponse.data) {
            dispatch({
                type: actions.UPDATE_USER,
                userData: {
                    ...omit(user, ['id']),
                    ...omit(newsResponse.data, ['id']),
                    ...omit(lawsResponse.data, ['id']),
                },
            });
            return 'ok';
        }
        if (isNewsUserLogged && !isLawsUserLogged && newsResponse.data) {
            dispatch({
                type: actions.UPDATE_USER,
                userData: { ...omit(user, ['id']), ...omit(newsResponse.data, ['id']) },
            });
            return 'ok';
        }
        if (isLawsUserLogged && !isNewsUserLogged && lawsResponse.data) {
            dispatch({
                type: actions.UPDATE_USER,
                userData: { ...omit(user, ['id']), ...omit(lawsResponse.data, ['id']) },
            });
            return 'ok';
        }
        if (newsResponse.error) return newsResponse.error;
        if (lawsResponse.error) return lawsResponse.error;
    };
}

// ALL PUBLICATIONS SAVED FILTERS
export const setAllPublicationsFeedUserFiltersSaving = (isFiltersSaving) => ({
    type: actions.SET_LAWS_ALL_PUB_USER_FILTERS_SAVING,
    isFiltersSaving,
});

export function saveAllPublicationsFeedFilters(filters) {
    return (dispatch, getState) => {
        dispatch(setAllPublicationsFeedUserFiltersSaving(true));
        const userId = getState().user.lawsUser.id;
        lawsAPI()
            .patch(`/users/${userId}/all_publications_feed_saved_filters/`, filters)
            .then(({ data }) => {
                if (data && data.success) {
                    dispatch({ type: actions.SAVE_LAWS_ALL_PUB_USER_FILTERS, filters });
                    toast(<SuccessMessage message="Фильтры сохранены!" />);
                }
            })
            .catch((error) => {
                dispatch(setAllPublicationsFeedUserFiltersSaving(false));
                toast(<ErrorMessage message={`Ошибка сохранения фильтров: ${error.message}`} />);
            });
    };
}

export function deleteAllPublicationsFeedUserFilters() {
    return (dispatch, getState) => {
        dispatch(setAllPublicationsFeedUserFiltersSaving(true));
        const userId = getState().user.lawsUser.id;
        lawsAPI()
            .patch(`/users/${userId}/all_publications_feed_saved_filters/`, null)
            .then(({ data }) => {
                if (data && data.success) {
                    dispatch({ type: actions.DELETE_LAWS_ALL_PUB_USER_FILTERS });
                    toast(<SuccessMessage message="Сохраненные фильтры удалены!" />);
                }
            })
            .catch((error) => {
                dispatch(setAllPublicationsFeedUserFiltersSaving(false));
                toast(<ErrorMessage message={`Ошибка удаления сохраненных фильтров: ${error.message}`} />);
            });
    };
}

// MY FAVORITES SAVED FILTERS
export const setMyFavoritesFeedUserFiltersSaving = (isFiltersSaving) => ({
    type: actions.SET_LAWS_MY_FAV_USER_FILTERS_SAVING,
    isFiltersSaving,
});

export function saveMyFavoritesFeedFilters(filters) {
    return (dispatch, getState) => {
        dispatch(setMyFavoritesFeedUserFiltersSaving(true));
        const userId = getState().user.lawsUser.id;
        lawsAPI()
            .patch(`/users/${userId}/my_favorites_feed_saved_filters/`, filters)
            .then(({ data }) => {
                if (data && data.success) {
                    dispatch({ type: actions.SAVE_LAWS_MY_FAV_USER_FILTERS, filters });
                    toast(<SuccessMessage message="Фильтры сохранены!" />);
                }
            })
            .catch((error) => {
                dispatch(setMyFavoritesFeedUserFiltersSaving(false));
                toast(<ErrorMessage message={`Ошибка сохранения фильтров: ${error.message}`} />);
            });
    };
}

export function deleteMyFavoritesFeedUserFilters() {
    return (dispatch, getState) => {
        dispatch(setMyFavoritesFeedUserFiltersSaving(true));
        const userId = getState().user.lawsUser.id;
        lawsAPI()
            .patch(`/users/${userId}/my_favorites_feed_saved_filters/`, null)
            .then(({ data }) => {
                if (data && data.success) {
                    dispatch({ type: actions.DELETE_LAWS_MY_FAV_USER_FILTERS });
                    toast(<SuccessMessage message="Сохраненные фильтры удалены!" />);
                }
            })
            .catch((error) => {
                dispatch(setMyFavoritesFeedUserFiltersSaving(false));
                toast(<ErrorMessage message={`Ошибка удаления сохраненных фильтров: ${error.message}`} />);
            });
    };
}

// MY ACTIONS SAVED FILTERS
export const setMyActionsFeedUserFiltersSaving = (isFiltersSaving) => ({
    type: actions.SET_LAWS_MY_ACTIONS_USER_FILTERS_SAVING,
    isFiltersSaving,
});

export function saveMyActionsFeedFilters(filters) {
    return (dispatch, getState) => {
        dispatch(setMyActionsFeedUserFiltersSaving(true));
        const userId = getState().user.lawsUser.id;
        lawsAPI()
            .patch(`/users/${userId}/my_actions_feed_saved_filters/`, filters)
            .then(({ data }) => {
                if (data && data.success) {
                    dispatch({ type: actions.SAVE_LAWS_MY_ACTIONS_USER_FILTERS, filters });
                    toast(<SuccessMessage message="Фильтры сохранены!" />);
                }
            })
            .catch((error) => {
                dispatch(setMyActionsFeedUserFiltersSaving(false));
                toast(<ErrorMessage message={`Ошибка сохранения фильтров: ${error.message}`} />);
            });
    };
}

export function deleteMyActionsFeedUserFilters() {
    return (dispatch, getState) => {
        dispatch(setMyActionsFeedUserFiltersSaving(true));
        const userId = getState().user.lawsUser.id;
        lawsAPI()
            .patch(`/users/${userId}/my_actions_feed_saved_filters/`, null)
            .then(({ data }) => {
                if (data && data.success) {
                    dispatch({ type: actions.DELETE_LAWS_MY_ACTIONS_USER_FILTERS });
                    toast(<SuccessMessage message="Сохраненные фильтры удалены!" />);
                }
            })
            .catch((error) => {
                dispatch(setMyActionsFeedUserFiltersSaving(false));
                toast(<ErrorMessage message={`Ошибка удаления сохраненных фильтров: ${error.message}`} />);
            });
    };
}

// WAITING SAVED FILTERS
export const setWaitingFeedUserFiltersSaving = (isFiltersSaving) => ({
    type: actions.SET_LAWS_WAITING_USER_FILTERS_SAVING,
    isFiltersSaving,
});

export function saveWaitingFeedFilters(filters) {
    return (dispatch, getState) => {
        dispatch(setWaitingFeedUserFiltersSaving(true));
        const userId = getState().user.lawsUser.id;
        lawsAPI()
            .patch(`/users/${userId}/waiting_feed_saved_filters/`, filters)
            .then(({ data }) => {
                if (data && data.success) {
                    dispatch({ type: actions.SAVE_LAWS_WAITING_USER_FILTERS, filters });
                    toast(<SuccessMessage message="Фильтры сохранены!" />);
                }
            })
            .catch((error) => {
                dispatch(setWaitingFeedUserFiltersSaving(false));
                toast(<ErrorMessage message={`Ошибка сохранения фильтров: ${error.message}`} />);
            });
    };
}

export function deleteWaitingFeedUserFilters() {
    return (dispatch, getState) => {
        dispatch(setWaitingFeedUserFiltersSaving(true));
        const userId = getState().user.lawsUser.id;
        lawsAPI()
            .patch(`/users/${userId}/waiting_feed_saved_filters/`, null)
            .then(({ data }) => {
                if (data && data.success) {
                    dispatch({ type: actions.DELETE_LAWS_WAITING_USER_FILTERS });
                    toast(<SuccessMessage message="Сохраненные фильтры удалены!" />);
                }
            })
            .catch((error) => {
                dispatch(setWaitingFeedUserFiltersSaving(false));
                toast(<ErrorMessage message={`Ошибка удаления сохраненных фильтров: ${error.message}`} />);
            });
    };
}

export function cleanUser() {
    console.log('+++CLEAN USER+++');
    return async (dispatch) => {
        localStorage.clear();
        dispatch({ type: actions.CLEAN_USER });
    };
}

export function logout() {
    console.log('+++LOGOUT USER+++');
    return async (dispatch, getState) => {
        dispatch(setUserFetching(true));
        const user = getState().user;
        const isNewsUserLogged = !checkUserExpirationDateExpired(user.newsUser.token_expires_at);
        const isLawsUserLogged = !checkUserExpirationDateExpired(user.lawsUser.token_expires_at);
        let isNewsOk = false;
        let isLawsOk = false;
        if (isNewsUserLogged) {
            isNewsOk = await newsAPI()
                .post('/auth/logout/')
                .then(({ data }) => data.success)
                .catch((error) => {
                    dispatch(setUserFetching(false));
                    console.error(error);
                    toast(<ErrorMessage message={`Ошибка при логауте новостного аккаунта: ${error.message}`} />);
                    return false;
                });
        }
        if (isLawsUserLogged) {
            isLawsOk = await lawsAPI()
                .post('/auth/logout/')
                .then(({ data }) => data.success)
                .catch((error) => {
                    dispatch(setUserFetching(false));
                    console.error(error);
                    toast(<ErrorMessage message={`Ошибка при логауте правового аккаунта: ${error.message}`} />);
                    return false;
                });
        }
        if (isNewsUserLogged && isLawsUserLogged && isNewsOk && isLawsOk) {
            dispatch({
                type: actions.LOGOUT,
            });
            localStorage.clear();
            resetAnalytics();
            return true;
        }
        if (isNewsUserLogged && !isLawsUserLogged && isNewsOk) {
            dispatch({
                type: actions.LOGOUT,
            });
            localStorage.clear();
            resetAnalytics();
            return true;
        }
        if (!isNewsUserLogged && isLawsUserLogged && isLawsOk) {
            dispatch({
                type: actions.LOGOUT,
            });
            localStorage.clear();
            resetAnalytics();
            return true;
        }
        console.log('no users were found, LOGGED OUT');
        dispatch(setUserFetching(false));
        localStorage.clear();
        resetAnalytics();
        return false;
    };
}

export const changeTheme = (theme) => ({
    type: actions.CHANGE_THEME,
    theme,
});



// WEBPACK FOOTER //
// ./src/redux_related/user/actionCreators.js